import { AxiosResponse, HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { DateHelper } from "@abaco/web-components/src/components/DateUtils";
import {
    ActionOut,
    Action,
    ActionFormDataOut,
    ActionMarker,
    TemporaryActionOut,
    CarbonFootprint
} from "../models/Action";
import { ViolationItem } from "../models/Activity";
import axios, { CancelTokenSource } from "axios";
import { toHAList, toHA } from "../models/Utils";
import { copyUnitMeasure } from "../models/Product";
import { BlockWithVariety } from "../models/Block";
import {
    ActivityFilter,
    Download,
    DownloadActivity,
    DownloadActivityOut,
    Filetype,
    UploadOut
} from "../models/Download";
import { NativeEventSource, EventSourcePolyfill } from "event-source-polyfill";

export default class DownloadApi {
    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }

    public async getDownloadFiletypes(pk_cuaa: number, campaign: number): Promise<Filetype[]> {
        const res = await this.http.get(
            `${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/activities_download/formats`
        );
        return res.data;
    }
    public async getUploadFiletypes(pk_cuaa: number, campaign: number): Promise<Filetype[]> {
        const res = await this.http.get(
            `${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions_upload/formats`
        );
        return res.data;
    }

    public async startDownload(detailOut: DownloadActivityOut[]): Promise<Download[]> {
        const res = await this.http.post(`/isoxml-activity-composer/api/v1/load/request-download`, detailOut);
        return res.data;
    }

    public async getDownloadStatus(downloadIds: number[]): Promise<EventSource> {
        const params = "request_id=" + downloadIds.join("&request_id=");
        const url = `/isoxml-activity-composer/api/v1/load/status-event-stream?${params}`;
        //return await this.http.eventSource(url, { headers: { Accept: "text/event-stream" } });
        return await this.http.eventSource(url);
    }

    public async getDownloadOld(downloadId: number): Promise<Blob> {
        const res = await this.http.get(`/isoxml-activity-composer/api/v1/load/download-file/${downloadId}`);
        return res.data;
    }

    public async getDownload(downloadId: number): Promise<AxiosResponse<any, any>> {
        const url = `/isoxml-activity-composer/api/v1/load/download-file/${downloadId}`;
        const res = await this.http.get(url, { responseType: "blob" });
        return res;
    }

    // public async getDownload(downloadId: numbe): Promise<Blob> {
    //     return (await this.unAuthHttp.get(url, { responseType: "blob", headers: { Authorization: `Bearer ${token}` } }))
    //         .data;
    // }

    public async uploadFile(pk_cuaa: number, form: UploadOut, file: File | null | undefined): Promise<any> {
        const formData = new FormData();
        if (file && file !== null && file !== undefined && form.file) {
            formData.append("file", form.file, file.name);
        }
        // if(analysisOut.type){
        //     formData.append("type", analysisOut.type);
        // }
        const res = await this.http.post(`/isoxml-activity-composer/api/v1/load/farm/${pk_cuaa}/upload`, formData);
        return res.data;
    }

    public async getPlannedActivities(
        pk_cuaa: number,
        campaign: number,
        activityFilters: ActivityFilter
    ): Promise<DownloadActivity[]> {
        let dateFormatted: string | undefined = undefined;
        if (activityFilters.from) {
            const newDate = new Date(activityFilters.from);
            newDate.setHours(2, 0, 0, 0);
            dateFormatted = newDate.toISOString();
            dateFormatted = dateFormatted.substring(0, dateFormatted.length - 5);
            dateFormatted = dateFormatted.replace("T", " ");
        }
        const res = await this.http.get(
            `${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/activities_download/activities`,
            {
                params: {
                    activity_descr: activityFilters.activity_descr ? activityFilters.activity_descr : undefined,
                    from: dateFormatted ? dateFormatted : undefined,
                    plot_id: activityFilters.plot_id ? activityFilters.plot_id : undefined,
                    plot_name: activityFilters.plot_name ? activityFilters.plot_name : undefined,
                    crop_descr: activityFilters.crop_descr ? activityFilters.crop_descr : undefined,
                    equipment_descr: activityFilters.equipment_descr ? activityFilters.equipment_descr : undefined,
                    limit_response: activityFilters.limit_response ? activityFilters.limit_response : undefined
                }
            }
        );
        return res.data.records;
    }
}
